import { render, staticRenderFns } from "./EventInformationDescriptionCard.vue?vue&type=template&id=31573dcc&scoped=true"
import script from "./EventInformationDescriptionCard.vue?vue&type=script&lang=js"
export * from "./EventInformationDescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./EventInformationDescriptionCard.vue?vue&type=style&index=0&id=31573dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31573dcc",
  null
  
)

export default component.exports